module.exports = __webpack_public_path__ + "img/csr_swiper_03_01.9cae34d5.jpg";